import { requestWrapper, unauthorized } from '@/api';
import type { ChangePasswordFormData } from '@/types/request';
import type { TFAResponse } from '@/types/auth';
import { VerifyTFA } from '@/service/tfa';

export async function Submit(data: ChangePasswordFormData): Promise<TFAResponse> {
  return await requestWrapper.post({
    path: '/user/settings/pass',
    body: data
  }).then(handleResponse);
}

export async function verifyTFA(response: TFAResponse, formData: ChangePasswordFormData) {
  return await VerifyTFA(response, `/user/settings/pass/verify`, { 'old': formData.old, 'new': formData.new })
    .then((response: Response) => {
      return handleResponse(response);
    });
}

async function handleResponse(response: Response) {
  if (!response.ok || unauthorized.includes(response.status)) {
    return Promise.reject(Error(response.statusText));
  }
  return await response.json().then((value: TFAResponse) => {
    return value;
  });
}
